/**
 * Origine publique d'`apps/tutor` (tutor.jeraisonne.fr) — sert à construire le
 * lien d'invitation d'une salle vidéo (`create_visio_invite`, migration 0259)
 * DEPUIS `apps/app`. Repli identique à celui de l'edge fn `visio-handoff-create`
 * (`Deno.env.get('TUTOR_URL') ?? 'https://tutor.jeraisonne.fr'`) — ici via
 * `VITE_TUTOR_URL` (optionnelle, non définie en prod aujourd'hui).
 */
export const TUTOR_APP_URL = (
  (import.meta.env.VITE_TUTOR_URL as string | undefined) ?? 'https://tutor.jeraisonne.fr'
).replace(/\/$/, '');

/** Lien qu'un hôte partage : `join_visio_room_by_invite` (migration 0259) l'accepte pour un compte réel ET une session anonyme. */
export function buildVisioInviteUrl(token: string): string {
  return `${TUTOR_APP_URL}/invite/${token}`;
}
